import React from 'react';

import Button from 'components/Button';
import './styles.css';

const Buttons = ({triggerSubmit, submitting, onClose}) => (
  <div className="Buttons">
    <Button onClick={onClose} transparent white className="Buttons__cancel">
      Cancel
    </Button>
    <Button
      onClick={triggerSubmit}
      className="Buttons__submit"
      blue={!submitting}
      isLoading={submitting}
      disabled={submitting}>
      Confirm
    </Button>
  </div>
);

export default Buttons;
